module.exports = __webpack_public_path__ + "img/nodata.5a202213.png";